export const CREATE_GUESS_DRIVER_GAME_COMPLETED = "guessdriver/createGameCompleted";
export const GET_GUESS_DRIVER_GAME_COMPLETED = "guessdriver/getGameCompleted";
export const ASK_QUESTION_COMPLETED = "guessdriver/askQuestionCompleted";
export const GUESS_PILOT_COMPLETED = "guessdriver/guessPilotCompleted";
export const GET_RECOMMENDATIONS_COMPLETED = "guessdriver/getRecommendationsCompleted";
export const GET_PILOT_SUGGESTIONS_COMPLETED = "GET_PILOT_SUGGESTIONS_COMPLETED";
export const CLEAR_PILOT_SUGGESTIONS = "CLEAR_PILOT_SUGGESTIONS";
